import SideMenu from "./parts/sideMenu";

export default SideMenu;
